/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable no-var */
/* eslint-disable no-use-before-define */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useRef } from 'react';
import { Badge, notification as notificationPopup } from 'antd';
import FeatherIcon from 'feather-icons-react';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Scrollbars } from 'react-custom-scrollbars';
import { useQuery, useSubscription } from '@apollo/client';
import { SketchOutlined } from '@ant-design/icons';
import { AtbdTopDropdwon, RingBellAnimation } from './auth-info-style';
import NotificationSideBar from './notification-sidebar/NotificationSideBar';
import { Popover } from '../../popup/popup';
import Heading from '../../heading/heading';
import { NOTIFICATION_QUERY_2 } from '../../../graphql-query/graphql-query';
import { setActiveLayoutAction, setDailogStatusAction } from '../../../redux/pricingLayoutDailog/actionCreator';
import { setNotificationGraphData } from '../../../redux/notification/actionCreator';
import 'dotenv/config';

const notificationContainer = title => {
  notificationPopup.info({
    message: `You have a new analysis`,
    description: title,
    duration: 6,
    key: title,
  });
};

const NotificationBox = () => {
  const [activeEnviornment, setActiveLayoutActionEnviornment] = useState('local');
  const dispatch = useDispatch();
  const [showPopover, togglePopoverView] = useState(false);
  const Symbol = useSelector(state => state.symbolData);
  const notification = useSelector(notificatioData => notificatioData.notification);
  // const mainDailog = useSelector(notificationState => notificationState.pricingLayoutDailogReducer);
  const [symbolCode, setSymbolCode] = useState('');
  // const notificationShown = useRef(false);
  // const notificationDestroyer = useState([]);
  const [activePage, setNotificationActivePage] = useState([0, 5]);
  const notificationData = useSubscription(NOTIFICATION_QUERY_2, {
    variables: {
      symbol_code: symbolCode,
    },
  });
  const { rtl } = useSelector(state => {
    return {
      rtl: state.ChangeLayoutMode.rtlData,
    };
  });

  useEffect(() => {
    console.log('Initializing Notification Popover Compoenent !');
    const currentEnviornment =
      process.env && process.env.REACT_APP_ENVIORNMENT === 'production'
        ? 'prod'
        : process.env && process.env.REACT_APP_ENVIORNMENT === 'development'
        ? 'dev'
        : 'local';
    setActiveLayoutActionEnviornment(currentEnviornment);
  }, []);

  useEffect(() => {
    console.log(Symbol);
    console.log('Notification Data 2 : ', notificationData);
    setSymbolCode(Symbol.selectedSymbol.symbolcode);
  }, [Symbol.selectedSymbol]);

  const renderThumb = ({ style, ...props }) => {
    const thumbStyle = {
      borderRadius: 6,
      backgroundColor: 'rgb(72 136 243 / 50%)',
    };
    return <div style={{ ...style, ...thumbStyle }} props={props} />;
  };

  const onClickViewAnalysis = notificationObject => {
    console.log('Updating Notification Status !');
    console.log('Notification Selected Object : ', notificationObject);
    if (notificationObject.payload.chart_type === 'table') {
      dispatch(setActiveLayoutAction('table_chart'));
    } else if (
      (notificationObject.category === 'test' || notificationObject.category === 'Analysis') &&
      notificationObject.payload.model_interaction === false
    ) {
      console.log('Action Layout : ', 'analysis_graph');
      dispatch(setActiveLayoutAction('analysis_graph'));
    } else {
      console.log('Action Layout : ', 'analyst_notification');
      dispatch(setActiveLayoutAction('analyst_notification'));
    }
    dispatch(setNotificationGraphData(notificationObject));
    console.log('Notification Updated Object : ', notification);
    dispatch(setDailogStatusAction(true));
    togglePopoverView(false);
  };

  const onTouchBellIcon = () => {
    if (showPopover === false) {
      togglePopoverView(true);
    } else {
      togglePopoverView(false);
    }
    moveToNextNotificationPage('reset');
  };

  const checkHowManyDaysPast = date => {
    var seconds = Math.floor((new Date() - new Date(date)) / 1000);
    var interval = seconds / 86400;
    if (interval > 5) {
      return false;
    }
    return true;
  };

  const checkIf14DaysPast = date => {
    var seconds = Math.floor((new Date() - new Date(date)) / 1000);
    var interval = seconds / 86400;
    if (interval > 14) {
      return false;
    }
    return true;
  };

  const openNotification = placement => {
    if (notificationData.data && notificationData.data.core_web_notifications) {
      notificationData.data.core_web_notifications
        .filter(x => (x.category === 'test' && activeEnviornment !== 'prod') || x.category !== 'test')
        .slice(0, 2)
        .map(x => {
          if (
            (x.category.toLowerCase() === 'analysis' || x.category.toLowerCase() === 'test') &&
            checkHowManyDaysPast(x.date)
          ) {
            return notificationContainer(x.title);
          }
        });
    }
  };

  useEffect(() => {
    if (notificationData.data && notificationData.data.core_web_notifications) {
      notificationData.data.core_web_notifications
        .filter(x => (x.category === 'test' && activeEnviornment !== 'prod') || x.category !== 'test')
        .slice(0, 2)
        .map(x => {
          if (
            (x.category.toLowerCase() === 'analysis' || x.category.toLowerCase() === 'test') &&
            checkHowManyDaysPast(x.date)
          ) {
            return notificationPopup.close(x.title);
          }
        });
    }
    if (notificationData.data && notificationData.data.core_web_notifications) {
      openNotification();
      console.log('Already Ran Once !');
    }
  }, [notificationData.data]);

  const renderTrackVertical = () => {
    const thumbStyle = {
      position: 'absolute',
      width: '6px',
      transition: 'opacity 200ms ease 0s',
      opacity: 1,
      [rtl ? 'left' : 'right']: '2px',
      bottom: '2px',
      top: '2px',
      borderRadius: '3px',
    };
    return <div className="hello" style={thumbStyle} />;
  };

  const renderView = ({ style, ...props }) => {
    const customStyle = {
      marginRight: rtl && 'auto',
      [rtl ? 'marginLeft' : 'marginRight']: '-17px',
    };
    return <div {...props} style={{ ...style, ...customStyle }} />;
  };

  const timeSince = date => {
    const seconds = Math.floor((new Date() - new Date(date)) / 1000);
    let interval = seconds / 31536000;
    if (interval > 1) {
      return `${Math.floor(interval)} years`;
    }
    interval = seconds / 2592000;
    if (interval > 1) {
      return `${Math.floor(interval)} months`;
    }
    interval = seconds / 86400;
    if (interval > 1) {
      return `${Math.floor(interval)} days`;
    }
    interval = seconds / 3600;
    if (interval > 1) {
      return `${Math.floor(interval)} hours`;
    }
    interval = seconds / 60;
    if (interval > 1) {
      return `${Math.floor(interval)} minutes`;
    }
    return `${Math.floor(seconds)} seconds`;
  };

  renderThumb.propTypes = {
    style: PropTypes.shape(PropTypes.object),
  };

  renderView.propTypes = {
    style: PropTypes.shape(PropTypes.object),
  };

  const moveToNextNotificationPage = params => {
    if (notificationData.data.core_web_notifications.length > activePage[1]) {
      setNotificationActivePage([activePage[0], activePage[1] + 5]);
    } else {
      setNotificationActivePage([0, 5]);
    }

    if (params === 'reset') {
      setNotificationActivePage([0, 5]);
    }
  };

  const content = (
    <AtbdTopDropdwon className="atbd-top-dropdwon">
      {notificationData.data && notificationData.data.core_web_notifications.length > 0 ? (
        <></>
      ) : (
        <Heading as="h5" className="atbd-top-dropdwon__title">
          <span className="title-text">No New Notification</span>
          <Badge className="badge-danger" count={0} />
        </Heading>
      )}

      <Scrollbars
        autoHeight
        hideTracksWhenNotNeeded={false}
        autoHide={false}
        renderThumbVertical={renderThumb}
        renderView={renderView}
        renderTrackVertical={renderTrackVertical}
      >
        <ul className="atbd-top-dropdwon__nav notification-list" style={{ height: 'auto' }}>
          {notificationData.data && notificationData.data.core_web_notifications ? (
            notificationData.data.core_web_notifications
              .filter(x => (x.category === 'test' && activeEnviornment !== 'prod') || x.category !== 'test')
              .slice(activePage[0], activePage[1])
              .map(x => (
                <li className="notification-hover" onClick={() => onClickViewAnalysis(x)}>
                  <div
                    className="atbd-top-dropdwon__content notifications"
                    style={{ padding: '13px 10px', paddingLeft: '0px' }}
                  >
                    <div className="notification-icon bg-primary">
                      <FeatherIcon icon={x.category === 'Analysis' ? 'bar-chart-2' : 'mail'} />
                    </div>
                    <div className="notification-content d-flex">
                      <div className="notification-text">
                        <Heading as="h5">
                          {x.payload && x.payload.chart_type ? (
                            <div onClick={() => onClickViewAnalysis(x)} style={{ color: '#8a8fa5', cursor: 'pointer' }}>
                              {x.title}
                            </div>
                          ) : (
                            <>{x.title}</>
                          )}
                        </Heading>
                        <p>{timeSince(x.date)} ago</p>
                      </div>
                      <div className="notification-status">{checkIf14DaysPast(x.date) ? <Badge dot /> : <></>}</div>
                    </div>
                  </div>
                </li>
              ))
          ) : (
            <></>
          )}
        </ul>
        {notificationData.data &&
        notificationData.data.core_web_notifications.length > 0 &&
        notificationData.data.core_web_notifications.length > activePage[1] ? (
          <Link
            className="btn-seeAll"
            style={{ width: '100%', color: '#4285f4' }}
            to="/dashboard"
            onClick={() => moveToNextNotificationPage('next')}
          >
            {notificationData.data.core_web_notifications.length > activePage[1] ? <>Load More Notification</> : <></>}
          </Link>
        ) : (
          <></>
        )}
      </Scrollbars>
    </AtbdTopDropdwon>
  );

  return (
    <div className="notification">
      <Popover
        overlayClassName="Pagal-Kiya"
        placement="bottomLeft"
        overlayInnerStyle={{ backgroundColor: 'blue' }}
        overlayStyle={{ backgroundColor: 'yellow' }}
        content={content}
        action="click"
        visible={showPopover}
      >
        <Badge dot={notificationData.data && notificationData.data.core_web_notifications.length > 0} offset={[-8, -5]}>
          <Link to="/dashboard" onClick={onTouchBellIcon} className="head-example">
            <RingBellAnimation>
              {/* <FeatherIcon
                className={
                  notificationData.data && notificationData.data.core_web_notifications.length > 0 ? 'bell' : ''
                }
                icon="bell"
                size={24}
              /> */}
              <FeatherIcon
                className={
                  notificationData.data && notificationData.data.core_web_notifications.length > 0 ? 'bell' : ''
                }
                icon="book"
                size={24}
              />
            </RingBellAnimation>
          </Link>
        </Badge>
      </Popover>
    </div>
  );
};

export default NotificationBox;
